<template lang="pug">
  
  app-dialog(v-model="$_show"  :header="'Создать сессию по делу'" width="400")
    v-form(ref="newSessionForm")
      v-layout.mt-1
        v-flex(xs8)
          app-date-picker(v-model="eventDate" format="YYYY-MM-DD" :viewFormat="'DD.MM.YYYY'" label="Дата заседания" :rules="[rules.required]")
        v-flex(xs4)
          app-select(v-model="eventTime" :items="timeIntervals" label="Время" :rules="[rules.required]") 
      app-button-action(@click="addSession()") добавить

</template>

<script>
import { AppDialogToggable } from '@/components'
import { mapState } from 'vuex'
import moment from '@/common/AppMoment.js'
import { caseService } from "@/_services"

import { $_validate_rules } from '@/common/ValidateRules'

export default {
  mixins: [AppDialogToggable, $_validate_rules],

  data () {
    return {
        eventDate: null,
        eventTime: null
    }
  },

  computed: {
    ...mapState('courtCase', ['courtCase']),

    timeIntervals () {
      var list = []
      for (var i = 8; i < 20; i++) {
        let hour = `0${i}`.slice(-2)
        list.push(`${hour}:00`)
        list.push(`${hour}:30`)
      }
      return list
    },
  },
  
  methods: {
    clearDateTime () {
      this.eventDate = null
      this.eventTime = null
    },

    addSession () {
      if (this.$refs.newSessionForm.validate()) {
        let count = this.courtCase.caseSessions.length + 1
        let obj = {
          eventDate: moment(this.eventDate).format('YYYY-MM-DD') + " " + this.eventTime,
          caseStatus: this.courtCase.status,
          name: count + " от " +  moment().format('DD.MM.YYYY HH:mm') ,
          courtCase: this.courtCase
        }
        caseService.addSession(obj).then(() => {
          this.$store.dispatch('courtCase/INIT', { caseId: this.courtCase.id })
          this.clearDateTime()
          this.$_show = false
        })
      }
    },
  }
}
</script>
